import { z } from 'zod'

import { ShippingAddressSchema } from '@/domain/shared/schemas/shipping-address.schema'

export const UpdateShippingAddressSchema = z
    .object({
        address_id: z.string().min(1),
    })
    .merge(ShippingAddressSchema)
